module.exports = __webpack_public_path__ + "img/enhanced-buzz.d7a23c5f.jpeg";